const shuttles = {
  shuttles: 'Shuttles',

  toast: {
    error: {
      badResponse: '[Shuttle] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Shuttle] updated successfully',
      },
      delete: {
        default: '[Shuttle] deleted successfully',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Error Occurred. Could Not Create Shuttle',
    },
    successToast: {
      message: 'Success! Shuttle Has Been Added Successfully',
    },
  },

  edit: {
    errorToast: {
      message: 'Error Occurred. Could Not Update Shuttle',
    },
    successToast: {
      message: 'Success! Shuttle Has Been Updated Successfully',
    },
  },

  createNew: 'Create',
  deleteBtn: 'Delete',

  deleteModal: {
    header: 'Delete Shuttles',
    body: 'You are about to delete {{num}} shuttles.',
  },
  table: {
    headers: {
      id: 'Id',
      line: 'Line',
      direction: 'Direction',
      weekdays: 'Weekdays',
      supplier: 'Supplier',
      pax: 'Pax',
    },
    notAvailable: 'Not Available',
    actions: {
      duplicate: 'Duplicate',
      delete: 'Delete',
      export: 'Export',
    },
  },

  form: {
    header: {
      createShuttle: {
        title: 'New Shuttle',
      },

      updateShuttle: {
        title: 'Shuttle',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    info: {
      details: {
        header: {
          create: 'Create Shuttle',
          edit: 'Edit Shuttle',
          information: 'Shuttle Information',
        },
        shuttleBy: {
          flexibleTime: 'Flexible Time',
          fixedTime: 'Fixed Time',
        },
        fields: {
          unit: 'Site',
          supplier: 'Operated By',
          hour1: 'From',
          hour2: 'To',
          shuttleBy: 'Shuttle By',
          code: 'Code',
          name: 'Name',
          area: 'Zone',
          line: 'Line',
          profile: 'Profile',
          direction: 'Direction',
          weekDays: 'Week Days',
          drivers: 'Drivers',
          pax: 'Pax',
          paymentType: 'Payment Type',
          routingType: 'Routing Type',
        },
        paymentTypeOptions: {
          free: 'Free',
          opusCard: 'OPUS Card',
          cashOnBoard: 'Cash On Board',
          correspondance: 'Correspondance',
        },
        routingTypeOptions: {
          dynamic: 'Dynamic',
          demand: 'Demand',
          bus: 'Bus',
        },
      },
      times: {
        header: 'Time',
        fields: {
          hour: 'Hour',
          limit: 'Limit',
          busses: 'Busses',
          holidays: 'Holidays',
        },
        btnAdd: 'Add Time',
      },
      stops: {
        header: 'Stops',
        fields: {
          address: 'Address',
          name: 'Name',
          zone: 'Zone',
          save: 'Save',
        },
        btnAdd: 'Add Stop',
      },
      zone: '(Zone: {{zone}})',
    },
    validation: {
      unitRequired: 'Site is required',
      codeRequired: 'Code is required',
      nameRequired: 'Name is required',
      paxRequired: 'Pax is required',
      hourRequired: 'Hour is required',
      limitRequired: 'Limit is required',
      latRequired: 'Latitude is required',
      lonRequired: 'Longitude it required',
    },
    weekDays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
  },
};

export default shuttles;
